const uiDictionary = {
        "en": {
            "done": "Done",
            "submit": "Submit",
            "next": "Next",
            "back": "Back",
            "cancel": "Cancel",
            "sign_in": "Sign In",
            "email": "Email",
            "password": "Password",
            "confirm_password": "Confirm Password",
            "given_name": "Given Name",
            "family_name": "Family Name",
            "forgot_password": "Forgot your password?",
            "create_account": "Create Account",
            "words": "words",
            "limit": "limit",
            "maximum": "maximum",
            "institution": "Institution",
            "presenting": "Presenting",
            "country": "Country",
            "save": "Save",
            "authornames": "Authors",
            "affiliations": "Affiliations",
            "add_author": "+ Add Author"
        },
        "es": {
            "next": "Siguiente",
            "back": "Atrás",
            "cancel": "Cancelar",
            "sign_in": "Iniciar sesión",
            "email": "Correo electrónico",
            "password": "Contraseña",
            "confirm_password": "Confirmar contraseña",
            "given_name": "Nombre",
            "family_name": "Apellido",
            "forgot_password": "¿Olvidaste tu contraseña?",
            "create_account": "Crear cuenta",
            "words": "palabras",
            "limit": "límite",
            "maximum": "máximo",
            "institution": "Institución",
            "presenting": "Presentando",
            "country": "País",
            "save": "Guardar",
            "authornames": "Autores",
            "affiliations": "Afiliaciones",
            "add_author": "+ Añadir autor"
        },
        "fr": {
            "done": "Terminé",
            "next": "Suivant",
            "back": "Retour",
            "cancel": "Annuler",
            "sign_in": "Se connecter",
            "email": "E-mail",
            "password": "Mot de passe",
            "confirm_password": "Confirmer le mot de passe",
            "given_name": "Prénom",
            "family_name": "Nom de famille",
            "forgot_password": "Mot de passe oublié ?",
            "create_account": "Créer un compte",
            "words": "mots",
            "limit": "limite",
            "maximum": "maximum",
            "institution": "Institution",
            "presenting": "Présentation",
            "country": "Pays",
            "save": "Enregistrer",
            "authornames": "Auteurs",
            "affiliations": "Affiliations",
            "add_author": "+ Ajouter un auteur"
        },
        "de": {
            "next": "Weiter",
            "back": "Zurück",
            "cancel": "Abbrechen",
            "sign_in": "Anmelden",
            "email": "E-Mail",
            "password": "Passwort",
            "confirm_password": "Passwort bestätigen",
            "given_name": "Vorname",
            "family_name": "Nachname",
            "forgot_password": "Passwort vergessen?",
            "create_account": "Konto erstellen",
            "words": "wörter",
            "limit": "grenze",
            "maximum": "maximum",
            "institution": "Institution",
            "presenting": "Präsentation",
            "country": "Land",
            "save": "Speichern",
            "authornames": "Autoren",
            "affiliations": "Zugehörigkeiten",
            "add_author": "+ Autor hinzufügen"
        },
        "it": {
            "next": "Avanti",
            "back": "Indietro",
            "cancel": "Annulla",
            "sign_in": "Accedi",
            "email": "Email",
            "password": "Password",
            "confirm_password": "Conferma Password",
            "given_name": "Nome",
            "family_name": "Cognome",
            "forgot_password": "Hai dimenticato la password?",
            "create_account": "Crea un account",
            "words": "parole",
            "limit": "limite",
            "maximum": "massimo",
            "institution": "Istituzione",
            "presenting": "Presentazione",
            "country": "Paese",
            "save": "Salva",
            "authornames": "Autori",
            "affiliations": "Affiliazioni",
            "add_author": "+ Aggiungi autore"
        },
        "pt": {
            "done": "Feito",
            "next": "Próximo",
            "back": "Voltar",
            "cancel": "Cancelar",
            "sign_in": "Entrar",
            "email": "E-mail",
            "password": "Senha",
            "confirm_password": "Confirmar senha",
            "given_name": "Nome",
            "family_name": "Sobrenome",
            "forgot_password": "Esqueceu sua senha?",
            "create_account": "Criar conta",
            "words": "palavras",
            "limit": "limite",
            "maximum": "máximo",
            "institution": "Instituição",
            "presenting": "Apresentando",
            "country": "País",
            "save": "Salvar",
            "authornames": "Autores",
            "affiliations": "Afiliações",
            "add_author": "+ Adicionar autor"
        },
        "ru": {
            "next": "Далее",
            "back": "Назад",
            "cancel": "Отмена",
            "sign_in": "Войти",
            "email": "Электронная почта",
            "password": "Пароль",
            "confirm_password": "Подтвердить пароль",
            "given_name": "Имя",
            "family_name": "Фамилия",
            "forgot_password": "Забыли пароль?",
            "create_account": "Создать аккаунт",
            "words": "слова",
            "limit": "предел",
            "maximum": "максимум",
            "institution": "Учреждение",
            "presenting": "Представление",
            "country": "Страна",
            "save": "Сохранить",
            "authornames": "Авторы",
            "affiliations": "Аффилиации",
            "add_author": "+ Добавить автора"
        },
        "zh": {
            "next": "下一步",
            "back": "返回",
            "cancel": "取消",
            "sign_in": "登录",
            "email": "电子邮件",
            "password": "密码",
            "confirm_password": "确认密码",
            "given_name": "名",
            "family_name": "姓",
            "forgot_password": "忘记密码？",
            "create_account": "创建账户",
            "words": "字数",
            "limit": "限制",
            "maximum": "最大",
            "institution": "机构",
            "presenting": "演示",
            "country": "国家",
            "save": "保存",
            "authornames": "作者",
            "affiliations": "单位",
            "add_author": "+ 添加作者"
        },
        "ja": {
            "next": "次へ",
            "back": "戻る",
            "cancel": "キャンセル",
            "sign_in": "サインイン",
            "email": "メール",
            "password": "パスワード",
            "confirm_password": "パスワードを認証する",
            "given_name": "名",
            "family_name": "姓",
            "forgot_password": "パスワードを忘れましたか？",
            "create_account": "アカウントを作成する",
            "words": "単語",
            "limit": "制限",
            "maximum": "最大",
            "institution": "機関",
            "presenting": "発表",
            "country": "国",
            "save": "保存",
            "authornames": "著者",
            "affiliations": "所属",
            "add_author": "+ 著者を追加"
        },
        "ar": {
            "next": "التالي",
            "back": "العودة",
            "cancel": "إلغاء",
            "sign_in": "تسجيل الدخول",
            "email": "البريد الإلكتروني",
            "password": "كلمة المرور",
            "confirm_password": "تأكيد كلمة المرور",
            "given_name": "الاسم الأول",
            "family_name": "اسم العائلة",
            "forgot_password": "هل نسيت كلمة المرور؟",
            "create_account": "إنشاء حساب",
            "words": "كلمات",
            "limit": "حد",
            "maximum": "الحد الأقصى",
            "institution": "المؤسسة",
            "presenting": "تقديم",
            "country": "البلد",
            "save": "حفظ",
            "authornames": "المؤلفون",
            "affiliations": "الانتماءات",
            "add_author": "+ إضافة مؤلف"
        }
    }
;

export default uiDictionary;
